import { type FunctionComponent } from "react";

import squareTakeoffIcon from "images/Common/squareTakeoffIcon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedSquareTakeoff: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img
            alt=""
            src={squareTakeoffIcon}
            style={baseProps.style}
            className={baseProps.className}
        />
    );
};
